import * as React from 'react';
import { DailyRentAnnotation, SaveDataAnnotation } from '../../components/AddNewCard';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { MobileDailyRentBanner } from '../../components/MobileDailyRentBanner';
import { useApplicationContext } from '../../utils/applicationContext';
import { tackShowDailyRentBanner, VIEWED_TIMEOUT } from './tracking';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

export const FormAnnotationContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const isDailyRentBannerActive = !!config.get<boolean>('valuationDailyRentBannerShow');
  const isDesktop = useIsDesktop();

  if (!isDesktop && isDailyRentBannerActive) {
    return (
      <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={() => tackShowDailyRentBanner('dailyRent')}>
        <MobileDailyRentBanner />
      </ActionAfterViewObserver>
    );
  }

  if (isDailyRentBannerActive) {
    return (
      <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={() => tackShowDailyRentBanner('dailyRent')}>
        <DailyRentAnnotation />
      </ActionAfterViewObserver>
    );
  }

  return <SaveDataAnnotation />;
};
